
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import _ from "lodash";
import $, { data } from 'jquery';
import axios from 'axios';
import Select  from 'react-select';
// import Grid from '../layouts/transporterComponent';
import { AgGridReact } from '@ag-grid-community/react';
import {AllModules} from '@ag-grid-enterprise/all-modules';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
//import {ChartMenu} from '@ag-grid-enterprise/charts/dist/es6/chartAdaptor/chartComp/menu/chartMenu';

import "@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";

import Modal from 'react-responsive-modal';
import Overlay from 'material-ui/internal/Overlay';
var moment = require('moment');
var redirectURL = require('../redirectURL');
var googleAnalytics = require("../common/googleanalytics");


export default class TransitMasterScreen extends Component {

    constructor(props){
        super(props);
        this.state={
            rowData:[],
            departmentCode: null,
            currentDepartmentTitle: null,
            // rowData:null,
            uploadDivWidth:'0%',
            sliderTranslate:'',
            showDiv:'show-n',
            alertshow:'fade',
            alertmg:'show-n',
            alerterrmg:'show-n',
            alerterrshow:'fade',
            alert:null,
            show: false,
            basicTitle:'',
            basicType:"default",
            pagetitle:"",
            usermanualmodal:false,
            overly: "show-n",
            sliderTrucksTranslate: "",
            loadshow:'show-n',
            modules:AllModules,
            plantList:[],
            plantCode:null,
            serviceList:[],
            serviceCode:null,
            consigneeList:[],
            consigneeCode:null,
            originalRowData:[],
            defaultColDef:{
                sortable: true,
				filter: true,
				resizable: true
            },
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left",
                    },
                    {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center",
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" },
                ],
            },
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel",
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel",
                    },
                ],
            },
        }
    }
  
    componentDidMount(){
      	
        this.loadPageData()
    };

    loadPageData = () => {

    this.setState({
        loadshow:"show-m",
        overly:"show-m"
    });

        redirectURL.post('/consignments/getTransitMaster')    
        .then((response) => {
          var records = response.data || [];

        //   console.log('records', response.data)
            let uniquePlantCode =[
                ...new Set(records.map(item=>item.plant_code))
            ]
            let plantList = [
                {label:'All',value:'All'},
                ...uniquePlantCode.map((plant)=>({
            label:plant,
            value:plant
            }))]


              let uniqueServiceProvider =[
                ...new Set(records.map(item=>item.service_provider))
            ]
            let serviceList =[
                {label:'All',value:'All'},
                ...uniqueServiceProvider.map((service)=>({
            label:service,
            value:service
            }))]

             let uniqueConsigneeCodes =[
                ...new Set(records.map(item=>item.consignee_code))
            ]
            let consigneeList = [
                {label:'All',value:'All'},
                ...uniqueConsigneeCodes.map((consignee)=>({
            label:consignee,
            value:consignee
            }))]


          this.setState({
              rowData:records,
              plantList:plantList,
              serviceList:serviceList,
              consigneeList:consigneeList,
              originalRowData:records,
              loadshow:"show-n",
              overly:"show-n"
          });
        })
        .catch( (error)=> {
          console.log("Error in getTransitMaster :",error);
          this.setState({
            loadshow:"show-n",
            overly:"show-n"
          })
          });
    }
  
    
    closeAlert = () => {
        this.setState({
            show: false
        });
    }
       onChangePlant = (selectedOption)=>{
        this.setState({
            plantCode:selectedOption,
        })
       }
       onChangeServiceProvider=(selectedOption)=>{
        this.setState({
            serviceCode:selectedOption,
        })
       }
       onChangeConsigneeCode=(selectedOption)=>{
        this.setState({
            consigneeCode:selectedOption,
        })
       }
       onClickFilterData=()=>{
        let selectedPlantCode=this.state.plantCode;
        let selectedServiceProvider=this.state.serviceCode
        let selectedConsigneeCode=this.state.consigneeCode
        // if(selectedPlantCode.value=='All'|| selectedServiceProvider.value=='All' || selectedConsigneeCode.value=="All"){
        //     this.loadPageData()
        // }
        if (
        (selectedPlantCode && selectedPlantCode.value === "All") ||
        (selectedServiceProvider && selectedServiceProvider.value === "All") ||
        (selectedConsigneeCode && selectedConsigneeCode.value === "All")
    ) {

        this.setState({
            rowData: this.state.originalRowData
        });

        return;
    }

      else if(selectedPlantCode && selectedServiceProvider && selectedConsigneeCode){
            let filteredData = this.state.originalRowData.filter(e=>
                e.plant_code==selectedPlantCode.value &&  e.consignee_code==selectedConsigneeCode.value && e.service_provider==selectedServiceProvider.value
            )
            if(filteredData.length===0){
                this.setState({
                    show:true,
                    basicType:"danger",
                    basicTitle:"Matchings were not Found",
                    loadshow:"show-n",
                    Overly:"show-n"
                })
            }
            else{
                 this.setState({
                rowData:filteredData
            })
            }
        }
         else if(selectedPlantCode && selectedServiceProvider){
            let filteredData = this.state.originalRowData.filter(e=>
                e.plant_code==selectedPlantCode.value &&  e.service_provider==selectedServiceProvider.value
            )
            if(filteredData.length===0){
                this.setState({
                    show:true,
                    basicType:"danger",
                    basicTitle:"Matchings were not Found",
                    loadshow:"show-n",
                    Overly:"show-n"
                })
            }
            else{
                 this.setState({
                rowData:filteredData
            })
            }
        }
        else if(selectedPlantCode &&  selectedConsigneeCode){
            let filteredData = this.state.originalRowData.filter(e=>
                e.plant_code==selectedPlantCode.value &&  e.consignee_code==selectedConsigneeCode.value
            )
             if(filteredData.length===0){
                this.setState({
                    show:true,
                    basicType:"danger",
                    basicTitle:"Matchings were not Found",
                    loadshow:"show-n",
                    Overly:"show-n"

                })
            }
            else{
                 this.setState({
                rowData:filteredData
            })
            }
        }

         else if(selectedServiceProvider &&  selectedConsigneeCode){
            let filteredData = this.state.originalRowData.filter(e=>
                e.service_provider==selectedServiceProvider.value &&  e.consignee_code==selectedConsigneeCode.value
            )
             if(filteredData.length===0){
                this.setState({
                    show:true,
                    basicType:"danger",
                    basicTitle:"Matchings were not Found",
                    loadshow:"show-n",
                    Overly:"show-n"
                })
            }
            else{
                 this.setState({
                rowData:filteredData
            })
            }
        }
        // else if(selectedPlantCode){
        //     let filteredData = this.state.originalRowData.filter(e=>
        //         e.plant_code==selectedPlantCode.value
        //     )
        //     this.setState({
        //         rowData:filteredData
        //     })
        // }
        else if(selectedPlantCode){
            // if(selectedPlantCode.value==='All')
            // {
            //     this.setState({
            //         rowData:this.state.originalRowData
            //     })
            // }
            
                 let filteredData = this.state.originalRowData.filter(e=>
                e.plant_code==selectedPlantCode.value
            )
            this.setState({
                rowData:filteredData
            })

            
           
        }

        else if(selectedServiceProvider){
            // if(selectedServiceProvider.value==='All'){
            //     this.setState({
            //         rowData:this.state.originalRowData
            //     })
            // }
            
             let filteredData = this.state.originalRowData.filter(e=>
                e.service_provider==selectedServiceProvider.value
            )
            this.setState({
                rowData:filteredData
            })
            
            
        }
         else if(selectedConsigneeCode){
            // if(selectedConsigneeCode.value==="All"){
            //     this.setState({
            //         rowData:this.state.originalRowData
            //     })
            // }
            
            let filteredData = this.state.originalRowData.filter(e=>
                e.consignee_code==selectedConsigneeCode.value
            )
            this.setState({
                rowData:filteredData
            })
            
            
        }
        else{
            this.setState({
                show:true,
                    basicType:"danger",
                    basicTitle:"Select any Filter",
                    loadshow:"show-n",
                    Overly:"show-n"
            })
        }
       }
       onClickFilterReset=()=>{
        // window.location.reload();
        this.setState({
            rowData:this.state.originalRowData,
            plantCode:null,
            consigneeCode:null,
            serviceCode:null

        })
       }
    render(){
        const columnwithDefs = [
                {
                  headerName: "Plant Code",
                  field: "plant_code",
                  width: 115,
                //  filter: true,
                filter: true, 
                
                },
                {
                  headerName: "Customer Code",
                  field: "consignee_code",
                  width: 115,
                  editable : false,
                  filter: true ,

                	          
                },
                {
                    headerName: "Transporter",
                    field: "service_provider",
                     width: 300,
                     filter: true, 
                    	          
                  },
                {
                    headerName: "Vehicle Mode",
                    field: "vehicle_mode",
                    width: 115,
                      filter: true, 
                },
                {
                  headerName: "Standard Transit Days",
                  field: "transit_time",
                  width: 115,
                 filter: true, 
                },
                {
                  headerName: "Customer Zone",
                  field: "zone",
                  width: 115,
                 filter: true, 
    
                }
        ];
        return(
            <div className="container-fluid">
            <SweetAlert
                show={this.state.show}
                type={this.state.basicType}
                title={this.state.basicTitle}
                onConfirm={this.closeAlert}
            > 
            </SweetAlert>
            <div className="card">
                    <div className="card-header">
                        <h5>
                            <i class="icofont icofont-vehicle-delivery-van cus-i"></i>
                            Transit Master
                        </h5>
                    </div>
                    <div className={(this.state.screenView == "Mobile")?"card-body":"card-body col-xl-12 col-lg-12"}>  
                        <div class="row">              
                            <div class="col-xl-3 col-lg-3 form-group">
                                <label>Plant Code</label>
                                {/* <input type="text" name="truck_no" id="truck_no" autoComplete="off" className="form-control" /> */}
                                <Select
                                    className="border-radius-0"
                                    isMulti={false}
                                    id="selectedFilter"
                                    name="truck_no"
                                    style={{ borderRadius: "0px" }}
                                    value={this.state.plantCode}
                                    options={this.state.plantList}
                                    onChange={this.onChangePlant}
                                    // placeholder="Select Truck No..."
                                    required
                                />
                            </div>
                            <div class="col-xl-3 col-lg-3 form-group">
                                <label>Service Provider</label>
                                {/* <input type="text" name="truck_no" id="truck_no" autoComplete="off" className="form-control" /> */}
                                <Select
                                    className="border-radius-0"
                                    isMulti={false}
                                    id="selectedFilter"
                                    style={{ borderRadius: "0px" }}
                                    value={this.state.serviceCode}
                                    options={this.state.serviceList}
                                    onChange={this.onChangeServiceProvider}
                                    required
                                />
                             </div>
                              <div class="col-xl-3 col-lg-3 form-group">
                                <label>Consignee Code</label>
                                {/* <input type="text" name="truck_no" id="truck_no" autoComplete="off" className="form-control" /> */}
                                <Select
                                    className="border-radius-0"
                                    isMulti={false}
                                    id="selectedFilter"
                                    style={{ borderRadius: "0px" }}
                                    value={this.state.consigneeCode}
                                    options={this.state.consigneeList}
                                    onChange={this.onChangeConsigneeCode}
                                    required
                                />
                             </div>
                            <div class="col-xl-2 col-lg-2 form-group">
                                <label>&nbsp;</label>
                                <br />
                                <button type="submit" onClick={this.onClickFilterData.bind(this)} class="btn btn-success">Submit</button>&nbsp;&nbsp;&nbsp;&nbsp;
                                <i title="Reset" onClick={this.onClickFilterReset.bind(this)} style={{ cursor: "pointer" }} class="icofont icofont-refresh"></i>
                            </div>
 
                        
                        </div>
                       
                    
                         
                    <div id="myGrid" style={{ height: "450px",width: "100%"}}  className="ag-theme-balham">
                                <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefs}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.rowData}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                sideBar={this.state.sideBar}
                                statusBar={this.state.statusBar}
                                />
                    </div>
                    </div>

                </div>
 
                  <div className={"dataLoadpage " +(this.state.loadshow)}>
				</div>
				<div className={"dataLoadpageimg " +(this.state.loadshow)}>
					<div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
				</div>
				{/* <div className={"overlay-part "+(this.state.overly)} onClick={this.onClickHideAll}></div> */}
                
            </div>
                
        );
    }
}

// $(document).on(".num-cls", function() {
//     this.value = this.value.replace(/\D\./g,'');
//     // this.value = this.value.replace(/[!#$%^*()+\=;'|<>\?a-zA-Z]+/g,"")

// });
